var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 8,
    viewBox: "0 0 24 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_926_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4149 7.76148H8.41309L9.66424 0.243408H11.6661L10.4149 7.75592V7.76148Z",
    fill: "#0055A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.95088 0.243255L5.04356 5.40915L4.81557 4.29701L4.14272 0.921661C4.05375 0.482366 3.6367 0.182088 3.19184 0.243255H0.0389249L0 0.371152C0.739574 0.549094 1.44578 0.838251 2.09639 1.2275L3.83689 7.75577H5.92215L9.10843 0.243255H6.95088Z",
    fill: "#0055A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1593 7.76129H23.9999L22.3929 0.243217H20.7803C20.3855 0.209853 20.0073 0.437842 19.8572 0.804848L16.8711 7.76129H18.9564L19.3734 6.64359H21.9202L22.1538 7.76129H22.1593ZM19.9573 5.10327L21.0083 2.28956L21.6033 5.10327H19.9573Z",
    fill: "#0055A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2268 2.05055L17.5104 0.437945C16.9321 0.237759 16.3204 0.126545 15.7087 0.109863C14.7133 0.109863 12.3556 0.532477 12.3556 2.60106C12.3556 4.54174 15.1248 4.56955 15.1248 5.58716C15.1248 6.60477 12.6392 6.42682 11.8218 5.78178L11.5215 7.47224C12.2388 7.76695 13.0062 7.91153 13.7847 7.89485C15.1526 7.89485 17.2156 7.19976 17.2156 5.32024C17.2156 3.44073 14.4186 3.18493 14.4186 2.33415C14.4186 1.48336 16.3704 1.59457 17.2268 2.05611V2.05055Z",
    fill: "#0055A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81557 4.39718L4.14272 0.938426C4.05931 0.493569 3.64226 0.187731 3.19184 0.243338H0.0389249L0 0.371234C1.08434 0.649269 2.10195 1.15529 2.97498 1.8615C3.80352 2.52879 4.43744 3.40182 4.82113 4.39162L4.81557 4.39718Z",
    fill: "#FC9220"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_926_2036"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.109863,
    width: 24,
    height: 7.78499,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/Visa.6d540e49d67b7286a1b10688481c2c59.svg";
export { ForwardRef as ReactComponent };